import { BusinessType } from './../interfaces/responsedata.ts/datatypes';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { AppdataService } from '../service/appdata.service';

@Pipe({
  name: 'getBusinessTypeNameById',
  standalone: false
})
export class GetBusinessTypeNameByIdPipe implements PipeTransform {

  dataService = inject(AppdataService);

  transform(value: string, lang: string = 'en'): string {
    let result = this.dataService.businessTypes.find(t => t.id === value);
    if (result) {
      return result[("name_" + lang) as keyof BusinessType];
    } else {

      return value;
    }
  }

}
